import { render, staticRenderFns } from "./PixForm.vue?vue&type=template&id=723e8e9f&scoped=true&"
import script from "./PixForm.vue?vue&type=script&lang=ts&"
export * from "./PixForm.vue?vue&type=script&lang=ts&"
import style0 from "./PixForm.vue?vue&type=style&index=0&id=723e8e9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723e8e9f",
  null
  
)

export default component.exports